<template lang="pug">
div
  template(v-if="!showMobile")
    topbar
    .conbox
      .hometabs
        tabList
  .tabbox
    .gbox-wrap.overflow-hidden
      reviewDisplay
      statisticsData
  footerInfo
</template>
<script>
import config from "@/config";
import topbar from '@/views/default/_topBar.vue'
import statisticsData from '@/component/_statisticsData.vue'
import reviewDisplay from '@/component/review/_reviewDisplay.vue'
import tabList from '@/views/default/_tabs.vue'
import footerInfo from '@/views/default/_footer.vue'
export default {
  components:{
    topbar,
    tabList,
    statisticsData,
    reviewDisplay,
    footerInfo
  },
  data(){
    return{
      feedback: {
        success: true,
        status: ""
      },
			loading:false,
      showMobile: false,
    }
  },
  created(){
    window.scroll(0,0)
		this.getSeo("review")
		this.checkSize()
    var vm = this
    $(window).resize(function () {
      vm.checkSize()
    });
	},
  methods:{
    getSeo(page){
      let page_name = page
      this.$store
        .dispatch("user/getSeo", {page_name})
        .then(response => {
          this.loading = false;
          this.feedback.success = response.success
          if (this.feedback.success == true) {
						if(response.data.length > 0){
							// this.$store.dispatch("user/seoInfo", response.data[0])
						}
          } else {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
            }       
          }
        })
        .catch(response => {
          this.loading = false;
          var vm = this;
          if((typeof response.status) != 'object'){
            this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
          }
        });
    },
    checkSize(){
      if ($(window).width() < 681) {
        this.showMobile = true
      }else{
        this.showMobile = false
      }
    },
  }
}
</script>